import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  CompanyItem,
  EventStateItem,
  OptionalItemList,
  TaskPriorityItem,
  TaskStateItem,
  UserItem,
} from "@winshop-crm/types";

type ItemListsState = {
  optionalItemLists: OptionalItemList[] | null;
  companiesItemList: CompanyItem[] | null;
  eventStatesItemList: EventStateItem[] | null;
  taskStatesItemList: TaskStateItem[] | null;
  taskPrioritiesItemList: TaskPriorityItem[] | null;
  usersItemList: UserItem[] | null;
};

const initialState: ItemListsState = {
  optionalItemLists: null,
  companiesItemList: null,
  eventStatesItemList: null,
  taskStatesItemList: null,
  taskPrioritiesItemList: null,
  usersItemList: null,
};

const itemListsSlice = createSlice({
  name: "itemLists",
  initialState,
  reducers: {
    setOptionalItemLists: (state, action: PayloadAction<OptionalItemList[] | null>) => {
      state.optionalItemLists = action.payload;
    },
    setCompaniesItemList: (state, action: PayloadAction<CompanyItem[] | null>) => {
      state.companiesItemList = action.payload;
    },
    setEventStatesItemList: (state, action: PayloadAction<EventStateItem[] | null>) => {
      state.eventStatesItemList = action.payload;
    },
    setTaskStatesItemList: (state, action: PayloadAction<TaskStateItem[] | null>) => {
      state.taskStatesItemList = action.payload;
    },
    setTaskPrioritiesItemList: (state, action: PayloadAction<TaskPriorityItem[] | null>) => {
      state.taskPrioritiesItemList = action.payload;
    },
    setUsersItemList: (state, action: PayloadAction<UserItem[] | null>) => {
      state.usersItemList = action.payload;
    },
  },
});

export const {
  setOptionalItemLists,
  setCompaniesItemList,
  setEventStatesItemList,
  setTaskStatesItemList,
  setTaskPrioritiesItemList,
  setUsersItemList,
} = itemListsSlice.actions;
export default itemListsSlice.reducer;
